import React, { useState, useRef } from "react";
import ColorPickerPopup from "./ColorPickerPopup";
import { ColorIndicator } from "./styled";
import SvgImage from "components/SvgImage/SvgImage";

const ColorPickerButton = ({
  icon,
  onColorChange,
  isDisabled = false,
  currentTextColor = "#000000",
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const buttonRef = useRef(null);
  const savedSelectionRef = useRef(null);

  // Use currentTextColor from props directly
  const displayColor = currentTextColor || "#000000";

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isDisabled) return;

    // Save current selection before opening picker
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      savedSelectionRef.current = {
        startContainer: range.startContainer,
        startOffset: range.startOffset,
        endContainer: range.endContainer,
        endOffset: range.endOffset,
      };
    }

    setShowPicker((prev) => !prev);
  };

  const handleColorChange = (color) => {
    if (savedSelectionRef.current) {
      try {
        const selection = window.getSelection();
        const range = document.createRange();
        range.setStart(
          savedSelectionRef.current.startContainer,
          savedSelectionRef.current.startOffset
        );
        range.setEnd(
          savedSelectionRef.current.endContainer,
          savedSelectionRef.current.endOffset
        );
        selection.removeAllRanges();
        selection.addRange(range);
        console.log('[ColorPickerButton] Selection restored');
      } catch (e) {
        console.error('[ColorPickerButton] Failed to restore selection:', e);
        return e;
      }
    }
 onColorChange(color);
    
    // Close popup after color is applied
    handleClose();
  };

  const handleClose = () => {
    setShowPicker(false);
    savedSelectionRef.current = null;
  };

  return (
    <div
      ref={buttonRef}
      style={{
        position: "relative",
        display: "inline-block",
      }}
    >
      <button
        onClick={handleClick}
        className={'w-14 h-9 border flex items-center justify-center hover:bg-gray-100 transition-colors hover:cursor-pointer'}
        style={{
          opacity: isDisabled ? 0.4 : 1,
          cursor: isDisabled ? "auto" : "pointer",
        }}
        disabled={isDisabled}
      >
        <SvgImage src={icon} width={24} height={24} />
        <ColorIndicator $color={displayColor} />
      </button>

      {showPicker && (
        <ColorPickerPopup
          currentColor={displayColor}
          onColorChange={handleColorChange}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default ColorPickerButton;
